module.exports = __webpack_public_path__ + "static/media/envelope-open-dollar.3d47887e.svg";